import { render, staticRenderFns } from "./PopupWindow.vue?vue&type=template&id=067b2382&scoped=true&"
import script from "./PopupWindow.vue?vue&type=script&lang=js&"
export * from "./PopupWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopupWindow.vue?vue&type=style&index=0&id=067b2382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b2382",
  null
  
)

export default component.exports